import { Box, Button, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface IApplicationViewModalProps {
  handleDismiss: () => void;
  username: string;
  email: string;
  profilePicture: string;
  phone: string;
  handleAccept: () => void;
  handleReject: () => void;
}

function ApplicationViewModal({
  handleDismiss,
  username,
  email,
  profilePicture,
  phone,
  handleAccept,
  handleReject,
}: IApplicationViewModalProps) {
  const { t } = useTranslation();

  return (
    <Grid
      item
      p="32px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap="36px"
    >
      {/* First row */}
      <Box display="flex" alignItems="center" justifyContent="center">
        <img
          src={
            profilePicture
              ? `${process.env.REACT_APP_MEDIA_FILES_BASE_URL}/${profilePicture}`
              : '/assets/images/empty-profile.jpg'
          }
          alt="bin"
          style={{
            width: '72px',
            height: '72px',
            objectFit: 'cover',
          }}
        />
      </Box>
      {/* Second row */}
      <Box display="flex" flexDirection="column" gap="12px">
        <Box display="flex" alignItems="center" flexDirection="column">
          <Typography variant="h5" color="#001E1D" textAlign="center">
            {username}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" flexDirection="column" gap="4px">
          <Typography variant="bodyRegular" color="#001E1D" textAlign="center">
            {phone}
          </Typography>
          <Typography variant="bodyRegular" color="#001E1D" textAlign="center">
            {email}
          </Typography>
        </Box>
      </Box>
      {/* Third row */}
      <Box display="flex" flexDirection="column" gap="8px">
        <Typography variant="bodyBold" color="#001E1D" textAlign="center">
          {t('applicationView.usualClients')}
        </Typography>
        <Typography variant="bodyRegular" color="#001E1D" textAlign="center">
          Young adults with anxiety
        </Typography>
      </Box>
      {/* Forth row */}
      <Box display="flex" flexDirection="column" gap="8px">
        <Typography variant="bodyBold" color="#001E1D" textAlign="center">
          {t('applicationView.therapyTypeAndMethods')}
        </Typography>
        <Typography variant="bodyRegular" color="#001E1D" textAlign="center">
          CBT Therapy, Art Therapy
        </Typography>
      </Box>
      {/* Fifth row */}
      <Box display="flex" flexDirection="column" gap="8px">
        <Typography variant="bodyBold" color="#001E1D" textAlign="center">
          {t('applicationView.certifications')}
        </Typography>
        <Box display="flex" alignItems="center" flexDirection="column" gap="4px">
          <Typography variant="bodyRegular" color="#001E1D" textAlign="center">
            Certificate_Name.pdf
          </Typography>
          <Typography variant="bodyRegular" color="#001E1D" textAlign="center">
            Certificate_Name_2.pdf
          </Typography>
        </Box>
      </Box>
      {/* Sixth row */}
      <Grid display="flex" gap="12px" xs={8}>
        <Button variant="outlined" color="primary" onClick={handleDismiss} fullWidth>
          {t('applicationView.dismiss')}
        </Button>
        <Button type="submit" variant="outlined" color="warning" onClick={handleReject} fullWidth>
          {t('applicationView.reject')}
        </Button>
        <Button type="submit" variant="contained" color="primary" onClick={handleAccept} fullWidth>
          {t('applicationView.accept')}
        </Button>
      </Grid>
    </Grid>
  );
}

export default ApplicationViewModal;
